import { useState } from 'react';

import PropTypes from 'prop-types';
import { BsFunnel, BsFunnelFill } from 'react-icons/bs';

import Panel from '#globalComponents/Overlay/Panel';
import Popover from '#globalComponents/Overlay/Popover';

const HeaderFilter = ({ label, active, children }) => {
	const [open, setOpen] = useState(false);

	const trigger = (
		<button
			type="button"
			onClick={() => setOpen((prev) => !prev)}
			title={label}
			className={`relative p-0.5 rounded transition-colors ${active ? 'text-primary-600' : 'text-bgBase-800 hover:text-bgBase-800'}`}
		>
			{active ? <BsFunnelFill className="w-3.5 h-3.5" /> : <BsFunnel className="w-3.5 h-3.5" />}
			{active && <span className="absolute -top-0.5 -right-0.5 w-1.5 h-1.5 rounded-full bg-purple-600" />}
		</button>
	);

	return (
		<Popover open={open} onClose={() => setOpen(false)} trigger={trigger} size="s" align="center">
			<Panel.Body className="text-left font-normal normal-case">{children}</Panel.Body>
		</Popover>
	);
};

HeaderFilter.propTypes = {
	label: PropTypes.string.isRequired,
	active: PropTypes.bool.isRequired,
	children: PropTypes.node.isRequired,
};

export default HeaderFilter;
